import { gql } from 'graphql-tag';
import { responseField } from '../../../../base.graphql';

export const systemUserRoleFields = `
  id
  uniqueId
  roleName
  roleIsSuperAdmin
  roleDescription
  roleCreateddate
  permissions {
    id
    uniqueId
    permissionName
    permissionCode
    permissionCreateddate
  }
`;

export const GET_ALL_SYSTEM_USER_ROLES = gql`
  query GetAllSystemUserRoles($uniqueId: String) {
    getAllSystemUserRoles(uniqueId: $uniqueId) {
      response {
          ${responseField}
        }
      data {
          ${systemUserRoleFields}
        }
    }
  }
`;

export const UPDATE_SYSTEM_USER_ROLE = gql`
mutation UpdateUserRolesMutation($input: UserRolesInput!) {
  updateUserRolesMutation(input: $input) {
      response {
          ${responseField}
        }
      data {
          ${systemUserRoleFields}
        }
    }
  }
`;

export const DELETE_SYSTEM_USER_ROLE = gql`
mutation DeleteUserRolesMutation($uniqueId: String!) {
  deleteUserRolesMutation(uniqueId: $uniqueId) {
    response {
        ${responseField}
      }
  }
}
`;

export const CREATE_SYSTEM_USER_ROLE = gql`
mutation CreateUserRolesMutation($input: UserRolesInput!) {
  createUserRolesMutation(input: $input) {
    response {
        ${responseField}
      }
    data {
        ${systemUserRoleFields}
      }
  }
}
`;
